import { createPortal } from "react-dom";

export const DEFAULT_OPTIMIZE_CONFIRMATION = {
  eyebrow: "Re-optimisation",
  title: "Confirmer la re-optimisation de la flotte ?",
  description: "Recalcule les tournées, la carte et les indicateurs en respectant les verrous.",
  impactItems: [],
  summaryItems: [],
  confirmLabel: "Optimiser maintenant",
  cancelLabel: "Annuler",
  tone: "accent",
};

export function resolvePillTone(className = "") {
  if (className.includes("danger")) {
    return "danger";
  }

  if (className.includes("warning")) {
    return "warning";
  }

  if (className.includes("success")) {
    return "success";
  }

  if (className.includes("soft")) {
    return "soft";
  }

  if (className.includes("outline-solid")) {
    return "outline-solid";
  }

  if (className.includes("idle")) {
    return "idle";
  }

  return "info";
}

export function dataAttributeProps(attributeName) {
  return attributeName ? { [attributeName]: true } : {};
}

export function resolveMetricAction(metric, interactions = {}) {
  if (!metric?.isInteractive) {
    return null;
  }

  if (metric.sourceChangesMenuTrigger) {
    return () => {
      interactions.onOpenSourceChangesMenu?.();
    };
  }

  if (metric.scrollTargetId) {
    return () => {
      if (metric.scrollDetailView) {
        interactions.onOpenDetailView?.(metric.scrollDetailView, { clearHash: true, scroll: false });
      }

      if (typeof document === "undefined") {
        return;
      }

      const scrollToTarget = () => {
        const target = document.getElementById(metric.scrollTargetId);
        if (!(target instanceof HTMLElement)) {
          return;
        }

        target.scrollIntoView({
          behavior: "smooth",
          block: metric.scrollBlock || "start",
          inline: "nearest",
        });
      };

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(scrollToTarget);
      });
    };
  }

  if (metric.errorTrigger) {
    return () => {
      interactions.onOpenError?.({
        errorId: metric.errorId || "",
        filter: metric.errorFilter || "",
        source: metric.errorSource || "",
        viewName: metric.errorViewName || "errors",
      });
    };
  }

  if (metric.detailViewLink) {
    return () => {
      if (metric.detailForceOpen) {
        interactions.onOpenDetailView?.(metric.detailViewLink, { clearHash: true, scroll: true });
        return;
      }

      interactions.onToggleDetailView?.(metric.detailViewLink, { clearHash: true, scroll: true });
    };
  }

  return null;
}

export function resolveTruckCardAction(card, interactions = {}) {
  if (!card?.asButton || !card.errorTrigger) {
    return null;
  }

  return () => {
    interactions.onOpenError?.({
      filter: card.errorFilter || "",
      source: card.errorSource || "",
      viewName: card.errorViewName || "errors",
    });
  };
}

export function renderPanelPortal(container, content) {
  if (!(container instanceof HTMLElement) || !content) {
    return null;
  }

  return createPortal(content, container);
}
